import { render, staticRenderFns } from "./CFlow.vue?vue&type=template&id=1fa2ed97"
import script from "./CFlow.vue?vue&type=script&lang=js"
export * from "./CFlow.vue?vue&type=script&lang=js"
import style0 from "./CFlow.vue?vue&type=style&index=0&id=1fa2ed97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports